import {
  GET_EXPORTDEVICETYPES_CATALOG,
  GET_EXPORTDEVICETYPES_CATALOG_SUCCESS,
  GET_EXPORTDEVICETYPES_CATALOG_ERROR,
} from '../../../constants/constantsRed';

export const postExportDeviceTypesCatalogRed = (
  state: any = false,
  actions: any
) => {
  switch (actions.type) {
    case GET_EXPORTDEVICETYPES_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case GET_EXPORTDEVICETYPES_CATALOG_ERROR:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case GET_EXPORTDEVICETYPES_CATALOG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
